import Phaser from 'phaser'

export class Background extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
    scene.add.existing(this)
    this.createBackground()
  }

  createBackground() {}

  destroy(fromScene?: boolean): void {
    this.removeAll(true)
    super.destroy(fromScene)
  }
}

export class NoBackground extends Background {}
